import React, { ReactElement } from 'react'
import { CircularProgress } from '@mui/material'

export interface ISpinnerProps {
	dependency: boolean,
	text?: string | React.ReactNode,
	children?: React.ReactNode,
	fullHeight?: boolean
	className?: string
}

const Spinner: React.FunctionComponent<ISpinnerProps> = ({ dependency, text, children, fullHeight = false, className }) => {
	return (
		<>
			{
				dependency ? (
					<div className={(fullHeight ? "hwi-spinner hwi-spinner-full-height" : "hwi-spinner") + (className ? " " + className : "")}>
						<div className="hwi-spinner-circle-container">
							<CircularProgress color="primary" />
						</div>
						{text &&
							<div>
								{text}
							</div>
						}
					</div>
				) : (
					<>
						{children}
					</>
				)
			}
		</>
	)
}

export default Spinner;